module.exports = __webpack_public_path__ + "static/hero-laptop-3-2e34a6c108d0f09aa41064a0aa74ef81.png";